module.exports = __webpack_public_path__ + "static/media/engineering.84d5fae3.png";